import { useSelector } from "react-redux";
import Flash from "./Flash";

const Flashes = () => {
  const flashes = useSelector((state) => state.flashes);
  return flashes.map((flash) => <Flash flash={flash} key={flash.key} />);
};

export default Flashes;
